import {
  MerchantOnboardingFieldRequirement,
  type MerchantOnboardingField,
  type MerchantOnboardingFieldKey,
  type SetMerchantOnboardingFieldsPayload,
} from './types';

/**
 * Builds the PUT body from the edited draft, sending ONLY the keys whose requirement
 * actually changed.
 *
 * watchman upserts every key it is handed (writing a row and flipping `isDefault` to false),
 * so sending the whole table would silently convert all ten platform defaults into admin
 * overrides on the first save — and there is no reset route to undo that. Diffing keeps the
 * `isDefault` badge truthful.
 */
export function buildOnboardingFieldsPayload(
  serverFields: MerchantOnboardingField[],
  draft: Record<MerchantOnboardingFieldKey, MerchantOnboardingFieldRequirement>,
): SetMerchantOnboardingFieldsPayload {
  const changed = serverFields
    .filter((field) => draft[field.fieldKey] && draft[field.fieldKey] !== field.requirement)
    .map((field) => ({ fieldKey: field.fieldKey, requirement: draft[field.fieldKey] }));
  return { fields: changed };
}

/** Re-exported so callers can build a draft without importing the enum separately. */
export const { REQUIRED, OPTIONAL } = MerchantOnboardingFieldRequirement;
